module.exports = __webpack_public_path__ + "static/media/drone-674235_1920.03ebed65.jpg";